import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./AffichListFilms.css";

export default function AffichListFilms({ pcritere }) {
  const apiKey = "9b2511a35c2a1b656502230e8819a81c";

  const [listeFilms, setFilms] = useState([]);

  useEffect(() => {
    if (!pcritere) {
      setFilms([]);
      return;
    }
    const query = encodeURIComponent(pcritere);
    const url = `https://api.themoviedb.org/3/search/movie?api_key=${apiKey}&language=fr-FR&page=1&query=${query}`;
    fetch(url)
      .then((response) => response.json())
      .then((dataJSON) => {
        const filmsAvecAffiche = (dataJSON.results || []).filter(
          (film) => film.poster_path
        );
        setFilms(filmsAvecAffiche);
      })
      .catch((error) => console.log(error));
  }, [pcritere]);

  if (!pcritere) return null;

  return (
    <div className="search-container">
      <h3 className="search-title">Résultats pour “{pcritere}”</h3>
      {listeFilms.length === 0 ? (
        <p className="search-empty">Aucun résultat pour le moment.</p>
      ) : (
        <ul className="search-grid">
        {listeFilms.map((film) => (
          <li key={film.id} className="film-item">
            <Link to={`/detail/${film.id}`} className="film-link">
              <img
                className="film-poster"
                src={`https://image.tmdb.org/t/p/w500/${film.poster_path}`}
                alt={film.title}
                width="100%"
              />
            </Link>
            <div className="search-meta">
              <h4>{film.title}</h4>
              <span>{film.release_date ? film.release_date.slice(0, 4) : "—"}</span>
            </div>
          </li>
        ))}
        </ul>
      )}
    </div>
  );
}
